<template>
     <MetaTag :title="metaTitle" :description="metaDescription"/>   
    <NavBar/>
    <div class="banner-content">
      <div class="hero-text">
        <h2>Crafting marketing solutions for<br><strong>growing businesses</strong> with a touch <br> of customization since 2014</h2>
        <p>We are the maintenance support system for your requirements by catering customized solutions, regular updates, backup management, bug fixing, security monitoring, performance checks, content updates, hosting, and others.</p>
      </div>
      <div class="shape-float">
        <img class="img-posin-2" src="frontend/images/banner/Shape2.png" alt="">
      </div>
    </div>
    <div class="reigning-market-sec">
        <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="reigning-market-gray">
                            <p>Reigning Market Successfully with:</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="reigning-market-black h-100">
                            <div class="row w-100">
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <div class="reigning-market-black-inner-left">
                                        <h6>1000</h6>
                                        <p>Projects</p>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <div class="reigning-market-black-inner-right">
                                        <h6>700</h6>
                                        <p>clients</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
    <div class="core-activities custom-padding">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-12">
                    <div class="core-activities-left">
                        <h2>Core <strong>Activities</strong></h2>
                        <p>We create engaging solutions for businesses to become recognized brands in the market by adhering to core activities that make us special and outstanding.</p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12">
                    <div class="core-activities-right">
                        <img src="../assets/images/seven-box.svg" alt=""/>
                        <!-- <div class="row cs-gutter-y">
                            <div class="col-xl-4 col-lg-6 col-md-4 col-sm-12">
                                <div class="core-activities-right-card">
                                    <div class="core-activities-right-img">
                                       <img src='@/assets/images/pricing2/Activities-1.png' alt=""> 
                                    </div>
                                    <h6>Regular Updates</h6>
                                    <p>Theme, Plugins, Core CMS</p>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-4 col-sm-12">
                                <div class="core-activities-right-card">
                                    <div class="core-activities-right-img">
                                       <img src='@/assets/images/pricing2/Activities-2.png' alt=""> 
                                    </div>
                                    <h6>Backup Management</h6>
                                    <p>Database Backups & Routine Website</p>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-4 col-sm-12">
                                <div class="core-activities-right-card">
                                    <div class="core-activities-right-img">
                                       <img src='@/assets/images/pricing2/Activities-3.png' alt=""> 
                                    </div>
                                    <h6>Security Monitoring</h6>
                                    <p>Surveillance & rapid action for threats</p>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-4 col-sm-12">
                                <div class="core-activities-right-card">
                                    <div class="core-activities-right-img">
                                       <img src='@/assets/images/pricing2/Activities-4.png' alt=""> 
                                    </div>
                                    <h6>Bug Fixing</h6>
                                    <p>Identification and Solution of Prompt</p>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-4 col-sm-12">
                                <div class="core-activities-right-card">
                                    <div class="core-activities-right-img">
                                       <img src='@/assets/images/pricing2/Activities-5.png' alt=""> 
                                    </div>
                                    <h6>Performance Checks</h6>
                                    <p>Monitor site speed & performance</p>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-4 col-sm-12">
                                <div class="core-activities-right-card">
                                    <div class="core-activities-right-img">
                                       <img src='@/assets/images/pricing2/Activities-6.png' alt=""> 
                                    </div>
                                    <h6>Content Updates</h6>
                                    <p>Text Images & New Blog Posts</p>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="sign-Up-sec">
            <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-12">
                    <div class="sign-Up-sec-text">
                        <p>Sign Up to Know More</p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12">
                    <div class="sign-Up-sec-btn">
                        <button class="btn">Get in Touch</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="explore-plans-2 custom-padding">
        <div class="container">
            <h2 class="text-center">Explore Our <strong>Plans</strong></h2>
            <p class="text-center">Choose a plan and start your 14-day free trial. Generate appointments and leads or source talent online, risk-free.</p>
                <div class="row custom-gap custom-img-before">
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="plans-main">
                            <div class="plans-inner">
                                <h6>Basic Plan</h6>
                                <p>Are you looking to launch or renovate your site with new ideas? </p>
                                <div class="call-fitX">
                                    <span>From</span>
                                    <h5>$199<span>/month</span></h5>
                                    <h4>3 Months Commitment</h4>
                                    <button class="btn plans-btn">Get Started</button>
                                </div>
                            </div>
                            <div class="plans-mid">
                                <h4>Features:</h4>
                                <div class="plans-mid-sec">
                                    <ul>
                                        <li>Software Updates (Monthly)</li>
                                        <li>Website Backups (Monthly)</li>
                                        <li>Quarterly Audits of SEO</li>
                                        <li>2 Working Days or Less Turnaround</li>
                                        <li>24*7 Website Monitoring</li>
                                        <li>Spam Prevention & Clean Up</li>
                                        <li>Monthly Performance Report</li>
                                        <li>Content Population & Updating</li>
                                        <li>1 Dedicated Website Manager</li>
                                        <li>1 website support ticket/month</li>
                                        <li>Connect on Slack</li>
                                        <li>Meetings (30 mins per week)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="plans-main popular">
                            <div class="popular-sec d-flex justify-content-center align-items-center">
                                <span>Popular</span>
                            </div>
                            <div class="plans-inner">
                                <h6>Advanced Plan</h6>
                                <p>Ready to win the race of the digital market with some advanced designing features?</p>
                                <div class="call-fitX">
                                    <span>From</span>
                                    <h5>$519<span>/month</span></h5>
                                    <h4>6 Months Commitment</h4>
                                    <button class="btn plans-btn">Get Started</button>
                                </div>
                            </div>
                            <div class="plans-mid">
                                <h4>Features:</h4>
                                <div class="plans-mid-sec">
                                    <ul>
                                        <li>Software Updates (Weekly)</li>
                                        <li>Website Backups (Monthly)</li>
                                        <li>Monthly Audits of SEO</li>
                                        <li>1 Working Day or Less turnaround</li>
                                        <li>Fixing Broken Links</li>
                                        <li>Domain Name and Hosting</li>
                                        <li>24*7 Website Monitoring</li>
                                        <li>CDN Implementation</li>
                                        <li>Spam Prevention & Clean Up</li>
                                        <li>Quarterly Performance Report</li>
                                        <li>Content Population & Updating</li>
                                        <li>1 Dedicated Website Manager</li>
                                        <li>2 website support tickets/month</li>
                                        <li>Connect on Slack</li>
                                        <li>Meetings (60 mins per week)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="plans-main">
                            <div class="plans-inner">
                                <h6>Premium Plan</h6>
                                <p>You can try our premium plan to have a better version to flourish in the market!</p>
                                <div class="call-fitX">
                                    <span>From</span>
                                    <h5>$999<span>/month</span></h5>
                                    <h4>Lifetime Commitment</h4>
                                    <button class="btn plans-btn">Get Started</button>
                                </div>
                            </div>
                            <div class="plans-mid">
                                <h4>Features:</h4>
                                <div class="plans-mid-sec">
                                    <ul>
                                        <li>Software Updates (Weekly)</li>
                                        <li>Website Backups (Weekly)</li>
                                        <li>Weekly Audits of SEO</li>
                                        <li>12 Hours & Realtime Turnaround</li>
                                        <li>Fixing Broken Links</li>
                                        <li>Management of Branding & Listings</li>
                                        <li>Analytics Report (Monthly)</li>
                                        <li>Installation of New Plug-ins</li>
                                        <li>Weekly Audits of SEO</li>
                                        <li>Customized Services</li>
                                        <li>Domain Name and Hosting</li>
                                        <li>24*7 Website Monitoring</li>
                                        <li>Booster Bundle**</li>
                                        <li>CDN Implementation</li>
                                        <li>Spam Prevention & Clean Up</li>
                                        <li>Weekly Performance Report</li>
                                        <li>Content Population & Updating</li>
                                        <li>1 Dedicated Website Manager </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
    <div class="discount-2">
        <div class="container">
        <div class="discount-sec">
            <div class="discount-sec-fast">
                    <h2>When you sign up for <span>our website maintenance service, you get Booster Bundle,</span> which includes CDN services and Premium Plug-ins.</h2>
            </div>
            <div class="discount-sec-second">
                <div class="row">
                    <div class="col-lg-6 col-md-12 col-sm-12">
                        <div class="discount-sec-second-left">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-4">
                                    <div class="offer">
                                        <p class="m-0">Exciting <span>Offer</span></p>
                                    </div>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8">
                                    <div class="offer-text">
                                        <h3><strong>30% off </strong>and <strong>7 days free trial</strong></h3>
                                        <p>*Limited Time Offer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 btn-end">
                        <button class="btn discount-sec-second">Grab Your Discount </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    <div class="maintenance-offers-2 custom-padding">
        <div class="container">
            <div class="maintenance-offers-text">
                <h2><span>Steps We adhere to</span> <strong>Present Excellence</strong></h2>
                <p>For a smooth experience on the website, you can always go through the suitable packages that meet your requirements including budget and time. No worries anymore, soon you get to receive the following services with best-suited solutions:</p>
            </div>
        </div>
    </div>

    <div class="weekly-activities">
        <div class="container">
            <div class="weekly_act">
                
                <div class="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    <button class="nav-link active" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home" aria-selected="true">Weekly activities</button>
                    <button class="nav-link" id="v-pills-profile-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false">Monthly Activities</button>
                    <button class="nav-link" id="v-pills-messages-tab" data-bs-toggle="pill" data-bs-target="#v-pills-messages" type="button" role="tab" aria-controls="v-pills-messages" aria-selected="false">Quarterly Activities </button>
                </div>
                    <div class="tab-content" id="v-pills-tabContent">
                        <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                            <div class="weekly-activities-inner">
                                <h2>Weekly <strong>Activities</strong></h2>
                                <ul>
                                    <li>Regular checking and monitoring of the page’s loading without any error.</li>
                                    <li>Updating website software and plug-ins.</li>
                                    <li>Keeping a backup to ensure the storage of the prior version.</li>
                                    <li>Checking running of all forms.</li>
                                    <li>Monitoring whether the pages have any broken links.</li>
                                    <li>Identifying 404 errors and redirecting.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                            <div class="weekly-activities-inner">
                                <h2>Monthly <strong>Activities</strong></h2>
                                <ul>
                                    <li>Checking the website’s loading speed. </li>
                                    <li>Reviewing and rechecking the security scans. </li>
                                    <li>Inspecting website statistics from past activities </li>
                                    
                                </ul>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
                            <div class="weekly-activities-inner">
                                <h2>Quarterly <strong>Activities</strong></h2>
                                <ul>
                                    <li>Exploring the needs for any kind of updates, and cross-checking graphics and images.</li>
                                    <li>Analyzing the effectiveness of the SEO Web Designs </li>
                                    <li>Test and tweak forms, CTAs, and Pop-ups. </li>
                                    
                                </ul>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    </div>

   

    <div class="container">
        <div class="sign-Up-sec-2">
            <div class="discount-sec-second">
                <div class="row">
                    <div class="col-lg-6 col-md-12 col-sm-12">
                        <div class="discount-sec-second-left">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-4">
                                    <div class="offer">
                                        <p>Exciting <span>Offer</span></p>
                                    </div>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8">
                                    <div class="offer-text">
                                        <h3><strong>30% off </strong>and <strong>7 days free trial</strong></h3>
                                        <p>*Limited Time Offer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 btn-end">
                        <button class="btn discount-sec-second">Grab Your Discount </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="quesn">
        <div class="container">

        
        <div class="quesn_text">
            <h3> <span>Have Questions? </span>We can sort them out!!</h3>
        </div>

  
            <div class="maintanance">
               

                    <div class="accordion">
                        <div v-for="(item, index) in items" :key="index" class="accordion-item">
                            <button class="accordion-button" type="button" @click="toggleItem(index)">
                                <div class="maintan1">
                                    <h4>{{ item.title }}</h4>
                                    <div class="main_tan_img">
                                        <span :class="{'plus-icon': !item.open, 'minus-icon': item.open}"></span>
                                    </div>
                                </div>
                            </button>
                            <div v-if="item.open" class="accordion-collapse">
                                <!-- <div class="accordion-body">
                                {{ item.content }}
                                </div> -->
                                <div class="accordion-body" v-html="item.content"></div>
                            </div>
                        </div>
                    </div>

            </div>

        <div class="quesn_text2 ">
            <h3>Looking for the <span>Design & Development </span>of your website? Click on to explore what we have in store for <span>Design & Development Offers!</span></h3>
        </div>

        <div class="maintan_btn">
            <router-link to="/design-development-pricing" class="m_btn"  @click="moveUp"> Explore Our Website Design & Development Plans</router-link>
        </div>
    </div>
    </div>


    <StayConectedWith/>
<FooTer />

</template>

<script>
import { ref } from 'vue';
import MetaTag from '../components/MetaTag.vue'
import FooTer from './FooTer.vue'
import NavBar from './NavBar.vue'
import StayConectedWith from '../components/StayConectedWith.vue'
import { defineComponent } from 'vue';


export default defineComponent({
  name: 'MaintainancePricing',
  components: {
    NavBar,
    FooTer,
    StayConectedWith,
    MetaTag
  },

  setup() {
    const items = ref([
      { title: 'What do you mean by website maintenance?', content: 'Website maintenance refers to up-to-date websites to eliminate any kind of technical and other type of bugs that would affect the website’s performance negatively. Moreover, website maintenance focuses on elevating the performance of the website starting from updating to marketing, it plays an integral role.', open: false },
      { title: 'What is the cost of website maintenance?', content: 'Feel free to reach us by visiting our website: <a href="https://www.bigwavedevelopment.com/" ><b style="text-decoration: underline;">https://www.bigwavedevelopment.com/</b></a> Our experts can guide you through the pricing packages of website maintenance as per your requirements.', open: false },

      { title: 'How much time does website maintenance consume?', content: 'Website maintenance is a continuous activity that ensures the enhancement of the quality and performance of the website. As long as the procedure continues to make further changes in the website until it becomes seamless for the audiences to operate. Most importantly, by analyzing the needs of the project, the procedure will continue and make progress regularly. ', open: false },
      { title: 'Does website maintenance depend on various content management systems (CMS)?', content: 'Of course, different CMS is based on which website maintenance service varies such as involvement of WordPress Core Code and plugin updates makes a never-ending loop for developers. This is so because WordPress has plenty of CMS-specific issues related to security that seek regular attention to resolve.', open: false },
      { title: 'Will I get to communicate with the project manager? ', content: 'Definitely, you will get to communicate with the project manager, where you can explain your requirements to get your work done right. Additionally, you will be able to share other requirements to keep your website updated and accordingly, the project manager will get things done.', open: false },
      { title: 'What if there are issues after my site goes live? ', content: 'We assure you that once your site goes live, there won’t be any mistakes, and if you find any mistakes, they will be addressed at the very moment. Since we have a lifetime commitment in the premium pricing package, we can address whatever issues arise after your site goes live and in case of other plans as well, we will be diligent enough to cross-check everything. ', open: false },
      { title: 'How do you do On-Page Optimization?  ', content: 'Our team of experts works on the factors that help to increase the results in search engines. However, we optimize the website by implementing the right keywords and setting the standards as per the requirements of the website that can be easily picked up by the search engines.', open: false },
      { title: 'Do I need to apply for a website maintenance plan? ', content: 'Yes, you do need to pick a plan for your website maintenance as it will help to reflect your business on the site, which would focus on grabbing attention in the target market. Website maintenance is an important part as it helps to improve the site’s functionality and ensures it presents as an effective business for potential customers in the competitive business field.', open: false },
    ]);

    const toggleItem = (index) => {
      items.value.forEach((item, i) => {
        if (i !== index) {
          item.open = false;
        }
      });
      items.value[index].open = !items.value[index].open;
    };


    return {
      items,
      toggleItem
    };
},
data(){
    return {
        metaTitle:"Maintainance Pricing | Big Wave Development LLC",
        metaDescription:"Big Wave Development has the appropriate mix of young, mature, vibrant, and dynamic employees to meet your needs. Interested in learning more? Begin now. ",
    }
},
methods: {
    moveUp(){
           window.scrollTo(0,0);
      },
}


});

</script>

<style scoped>
.banner-content .hero-text p{
    margin-bottom: 0 !important;
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1rem 1.25rem;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  background-color: #fff;
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,border-radius .15s ease;
  cursor:pointer;
}

.accordion-button:not(.collapsed)::after {
    background-image: url('../assets/images/pricing2/minus.png');
}

.tab-content > .tab-pane {
  display: none;
}

.fade {
  transition: opacity .15s linear;
}

.fade:not(.show) {
  opacity: 0;
}

.tab-content > .active {
  display: block;
}

.banner-content {
	min-height: 260px;
    background: url('@/assets/images/pricing/pricing-banner-bg.svg');
	background-size: cover;
	background-repeat: no-repeat;
	background-position: 0 0;
}
.banner-content .hero-text p {
	font-size: 22px;
    line-height: 30px;
}
.reigning-market-sec {
    background:#000000;
    position: relative;
    overflow: hidden;
}

.maintanance .accordion-body{
    font-size: 16px;
    line-height: 25px;
    padding: 15px 20px 20px;
    border-top:1px solid #dfdfdf;
}

.reigning-market-sec::after {
	position: absolute;
	content: "";
	background: #1e1e1e;
	height: 100%;
	width: 1000%;
	top: 0;
	right: calc(50% + 100px);
}
.reigning-market-sec .reigning-market-gray {
    position: relative;
    padding: 80px 0; 
    width: 70%;
    z-index: 1;
}
.reigning-market-sec .reigning-market-gray::before {
	position: absolute;
	content: "";
	clip-path: polygon(0% 0%, 51% 0, 100% 50%, 50% 100%, 0% 100%);
	background: #1e1e1e;
	z-index: 1;
	left: 100%;
	width: 185px;
	height: 100%;
	top: 0;
}
.reigning-market-sec .reigning-market-gray p {
    font-size: 22px;
    color: #ffffff;
    font-weight: 600;
    line-height: 1.3;
}
.reigning-market-sec .reigning-market-black h6 {
    font-weight: bold;
    font-size: 70px;
    line-height: 1.3;
    color: #ffffff;
    text-align: center;
}
.reigning-market-sec .reigning-market-black p {
    font-weight: 600;
    font-size: 22px;
    line-height: 1.3;
    color: #D43F33;
    text-align: center;
    text-transform: uppercase;
}
.w-100 {
    width: 100%;
}
.reigning-market-sec .reigning-market-black {
	display: flex;
	justify-content: center;
	align-items: center;
    height: 100%;
}
.reigning-market-sec .reigning-market-black-inner-left {
    border-right: dashed 1px #ffffff;
}
.core-activities {
    background: url('@/assets/images/pricing2/activities.png');
    background-size: cover;
}
.core-activities .core-activities-right {
	position: relative;
}
.core-activities .core-activities-right::before {
	position: absolute;
	content: "";
	background: url('@/assets/images/pricing2/Activities-bg.svg');
	width: 75px;
	height: 107px;
	bottom: -50px;
	left: -100px;
}
.core-activities.custom-padding {
    padding: 50px 0;
}
.core-activities .core-activities-left {
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 100%;
}
.core-activities .core-activities-left h2 {
    font-weight: 300;
    font-size: 52px;
    line-height: 1.3;
    color: #000;
}
.core-activities .core-activities-left h2 strong {
    font-weight: bold;
}
.core-activities .core-activities-left p {
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #353535;
    width: 78%;
    padding-top: 30px;
}
.core-activities .core-activities-right-card {
	background: #ffffff;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 20px 25px;
    border-radius: 10px;
    filter: drop-shadow(0px 1px 3px rgba(0,0,0,0.12));
    height: 100%;
}
.core-activities .core-activities-right-card .core-activities-right-img {
    width: 40px;
    height: 40px;
}
.core-activities .core-activities-right-card h6 {
    font-weight: bold;
    font-size: 20px;
    line-height: 1.3;
    color: #000;
    text-align: center;
    padding: 15px 0 10px;
}
.core-activities .core-activities-right-card p {
    font-weight: 400;
    font-size: 15px;
    line-height: 1.3;
    color: #353535;
    text-align: center;
}
.cs-gutter-y {
    --bs-gutter-y: 25px;
}
.sign-Up-sec {
    background: #0A0A0A;
    border-radius: 10px;
    position: relative;
    padding: 70px;
    margin: 20px 0 20px;
}
.sign-Up-sec::before {
	position: absolute;
	content: "";
	background: url('@/assets/images/pricing2/Activities-bg.svg');
	width: 75px;
	height: 107px;
	bottom: -50px;
	left: -80px;
    background-size: contain;
}

.sign-Up-sec::after {
	content: "";
  position: absolute;
  width: 191px;
  height: 190px;
  background-image: url('@/assets/images/pricing/discount-before.svg');
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  bottom: -75px;
  right: -60px;
  z-index: -1;
  background-size: cover;
}

.plans-inner{
    background: url(../assets/images/pricing/gradient-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 10px 10px 0 0;
}

.sign-Up-sec-text p {
    font-weight: 600;
    font-size: 45px;
    line-height: 1.3;
    color: #ffffff;
}
.sign-Up-sec-btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.sign-Up-sec-btn .btn {
    color: #fff;
    background: #d43f33;
    border: 1px solid #d43f33;
    border-radius: 50px;
    padding: 10px 41px;
    font-size: 20px;
    font-weight: 300;
}
.sign-Up-sec-btn .btn:hover {
	background: #a92920;
}
.explore-plans-2 h2 {
    color: #000000;
    font-weight: 300;
    font-size: 52px;
    line-height: 1.3;
}
.explore-plans-2 h2 strong {
    font-weight: bold;
}
.explore-plans-2 p {
    color: #353535;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.3;
    padding: 25px 0 70px;
}
.explore-plans-2 .plans-main {
    border: 1px solid #DFDFDF;
    border-radius: 10px;
    transition: .3s ease-in-out;
    height: 100%;
    background: #ffffff;
}
.explore-plans-2 .plans-main .plans-inner {
    padding: 40px 30px 30px;
    min-height: 380px;
    display: flex;
    flex-direction: column;
}
.explore-plans-2 .plans-main .plans-inner h6 {
	font-size: 25px;
	color: #D33E32;
	line-height: 1.3;
	font-weight: bold;
}
.explore-plans-2 .plans-main .plans-inner p {
	color: #353535;
	font-weight: 400;
	font-size: 15px;
	line-height: 1.5;
    padding: 10px 0 20px;
}
.explore-plans .plans-main .plans-inner .call-fitX {
    margin-top: auto;
}
.explore-plans-2 .plans-main .plans-inner span {
	color: #000000;
	font-weight: 400;
	font-size: 15px;
	line-height: 1.3;
}
.explore-plans-2 .plans-main .plans-inner h5 {
	color: #000000;
	font-weight: bold;
	font-size: 48px;
	line-height: 1.2;
}
.explore-plans-2 .plans-main .plans-inner h5 span {
	color: #000000;
	font-weight: bold;
	font-size: 28px;
	line-height: 1.2;
}
.explore-plans-2 .plans-main .plans-inner h4 {
	color: #000000;
	font-weight: 400;
	font-size: 15px;
	line-height: 1.2;
}
.explore-plans-2 .plans-main .plans-inner .btn.plans-btn {
    color: #fff;
    background: #d43f33;
    border: 1px solid #d43f33;
    border-radius: 50px;
    padding: 10px 41px;
    width: 100%;
    margin: 25px 0;
    font-size: 20px;
    font-weight: 300;
}
.explore-plans-2.custom-padding {
    padding: 100px 0;
}
.explore-plans-2 .plans-main .plans-inner .btn.plans-btn:hover {
	background: #a92920;
}
.explore-plans-2 .plans-main .plans-mid {
	padding: 25px 35px;
    width: 100%;
}
.explore-plans-2 .plans-main .plans-mid h4 {
	font-size: 17px;
	font-weight: bold;
	color: #000;
	line-height: 1.3;
}
.explore-plans-2 .plans-main .plans-mid .plans-mid-sec ul li {
    padding: 12px 0 0 20px;
    position: relative;
    font-size: 15px;
}
.explore-plans-2 .plans-main .plans-mid .plans-mid-sec ul li:before {
    position: absolute;
    content:"";
    background: url('@/assets/images/pricing/plans-right.png');
    background-repeat: repeat;
    background-repeat: no-repeat;
    width: 9px;
    height: 7px;
    left: 0;
    top: 21px;
}
.explore-plans-2 .plans-main.popular {
    border: 2px solid #D33E32;
    position: relative;
}
.explore-plans-2 .plans-main.popular .popular-sec {
    background: #D43F33;
    width: fit-content;
    border-radius: 4px;
    padding: 2px 15px;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%,-50%);
}
.explore-plans-2 .plans-main.popular .popular-sec span {
    color: #ffffff;
    font-weight: 600;
    font-size: 11px;
    line-height: 1.7;
    display: block;
}
.custom-gap {
    --bs-gutter-x: 50px;
}
.explore-plans-2 .plans-main .plans-dropdown {
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #DFDFDF;
    border-radius: 0 0 10px 10px;
    width: 100%;
} 
.explore-plans-2 .plans-main .plans-dropdown a {
	color: #000;
	padding: 15px 30px;
	width: 100%;
	text-align: center;
    font-weight: 500;
    font-size: 15px;
}
.explore-plans-2 .custom-img-before {
	position: relative;
	z-index: 1;
}
.explore-plans-2 .custom-img-before::before {
	position: absolute;
	content: "";
	background: url('@/assets/images/pricing/plans-before.svg');
	background-repeat: no-repeat;
	width: 75px;
	height: 107px;
	right: -39px;
	bottom: -40px;
	z-index: -1;
    background-size: contain;
}
.discount-2 .discount-sec {
	background: #000;
	border-radius: 10px;
	padding: 80px 60px 30px;
	position: relative;
}
.discount-2 .discount-sec .discount-sec-fast h2 {
    color: #ffffff;
    font-weight: 600;
    font-size: 45px;
    line-height: 1.3;
}
.discount-2 .discount-sec .discount-sec-fast h2 span {
    color: #D43F33;
}
.discount-2 .discount-sec .discount-sec-fast {
	padding-bottom: 50px;
	border-bottom: 1px dashed #C4C4C4;
}
.discount-2 .discount-sec .discount-sec-second .btn.discount-sec-second {
	color: #fff;
	background: #d43f33;
	border: 1px solid #d43f33;
	border-radius: 50px;
	padding: 10px 41px;
	margin: 25px 0;
	font-size: 20px;
	font-weight: 300;
}
.discount-2 .discount-sec .discount-sec-second .btn.discount-sec-second:hover {
    background: #a92920;
}
.btn-end {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.discount-2 .discount-sec-back {
	margin-top: -90px;
	background: #0A0909;
	width: 100%;
	height: 90px;
    position: relative;
    border-radius: 0 0 10px 10px;
}
.discount-2 .discount-sec-second {
	padding-top: 30px;
    position: relative;
    z-index: 1;
}
.discount-2 .discount-sec-second-left .offer {
    position: relative;
    z-index: 1;
    padding: 40px;
}
.discount-2 .discount-sec-second-left .offer::before {
	position: absolute;
	content: "";
	background: url('@/assets/images/pricing/offer.png');
	width: 100%;
	height: 100%;
	background-size: contain;
	background-repeat: no-repeat;
	z-index: -1;
	left: 50%;
	top: 50%;
	transform: translate(-50%,-50%);
	background-position: center;
}
.discount-2 .discount-sec-second-left .offer p {
    color: #ffffff;
    font-weight:bold;
    font-size: 20px;
    line-height: 1.3;
    text-align: center;
}
.discount-2 .discount-sec-second-left .offer p span {
    display: block;
}
.discount-2 .discount-sec-second-left .offer-text {
	height: 100%;
	display: flex;
	justify-content: center;
	flex-direction: column;
}
.discount-2 .discount-sec-second-left .offer-text h3 {
    color: #ffffff;
    font-weight:300;
    font-size: 30px;
    line-height: 1.2;
    width: 80%;
}
.discount-2 .discount-sec-second-left .offer-text h3 strong {
    font-weight:bold;
}
.discount-2 .discount-sec-second-left .offer-text p {
    color: #ffffff;
    font-weight:500;
    font-size: 14px;
    line-height: 1.3;
    padding-top: 10px;
}
.discount-2 .discount-sec::before {
	content: "";
	position: absolute;
	width: 191px;
	height: 190px;
    background: url('@/assets/images/pricing/discount-before.svg');
	background-size: cover;
	background-position: 50%;
	background-repeat: no-repeat;
	bottom: -75px;
	left: -60px;
    z-index: -1;
    transform: rotateY(170deg);
}
.maintenance-offers-2.custom-padding {
	padding: 100px 0;
}
.maintenance-offers-2.custom-padding {
	padding: 80px 0 80px;
}
.maintenance-offers-2 .maintenance-offers-text {
	display: flex;
	flex-direction: column;
    align-items: center;
}
.maintenance-offers-2 .maintenance-offers-text h2 {
    color: #000000;
    font-weight:300;
    font-size: 45px;
    line-height: 1.3;
    text-align: center;
    padding-bottom: 40px;
}
.maintenance-offers-2 .maintenance-offers-text h2 span {
    display: block;
}
.maintenance-offers-2 .maintenance-offers-text h2 strong {
    font-weight:bold;
}
.maintenance-offers-2 .maintenance-offers-text p {
    color: #353535;
    font-weight:400;
    font-size: 16px;
    line-height: 1.3;
    text-align: center;
    width: 70%;
}
.weekly-activities #v-pills-tab {
    width: 30%;
}
.weekly-activities #v-pills-tabContent {
    width: 70%;
    padding-left: 65px;
}
.weekly-activities .nav-pills .nav-link {
	border-radius: 0;
	font-size: 21px;
	font-weight: 500;
	color: #000000;
	text-align: left;
	padding: 15px 80px 15px 20px;
    line-height: 1.3;
    transition: .3s ease-in-out;
    clip-path: polygon(0% 0%, 90% 0, 100% 50%, 90% 100%, 0% 100%);
    margin-bottom:10px;
    cursor: pointer;
    background: none;
}
.weekly-activities .nav-pills .nav-link.active {
    background-color: #D43F33;
    border-radius: 0 5px 5px 0;
    transition: .3s ease-in-out;
    color: #ffffff;
}
.weekly-activities .weekly-activities-inner h2 {
    color: #000;
    font-weight: 300;
    font-size: 35px;
    line-height: 1.3;
    margin-bottom: 20px;
}
.weekly-activities .weekly-activities-inner h2 strong {
    font-weight: bold;
}
.weekly-activities .weekly-activities-inner ul li {
    padding: 10px 0 0 35px;
    position: relative;
    font-size: 15px;
}
.weekly-activities .weekly-activities-inner ul li::before {
  position: absolute;
  content: "";
  background:url('@/assets/images/pricing/right.png');
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
  left: 0;
  /* top: 18px; */
}





.sign-Up-sec-2 {
    background: #000;
    border-radius: 10px;
    padding: 30px 50px;
    position: relative;
    margin-bottom: 127px;
}
.sign-Up-sec-2:before {
	content: "";
    position: absolute;
    width: 191px;
    height: 190px;
    background: url('@/assets/images/pricing/discount-before.svg');
    background-position-x: 0%;
    background-position-y: 0%;
    background-repeat: repeat;
    background-size: auto;
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
    bottom: -75px;
    right: -60px;
    z-index: -1;
}
.sign-Up-sec-2 .discount-sec-second-left .offer {
	position: relative;
	z-index: 1;
	padding: 40px;
}
.sign-Up-sec-2 .discount-sec-second-left .offer::before {
	position: absolute;
	content: "";
	background: url('@/assets/images/pricing/offer.png');
	width: 100%;
	height: 100%;
	background-size: contain;
	background-repeat: no-repeat;
	z-index: -1;
	left: 50%;
	top: 50%;
	transform: translate(-50%,-50%);
	background-position: center;
}
.sign-Up-sec-2 .discount-sec-second-left .offer p {
	color: #ffffff;
	font-weight: bold;
	font-size: 20px;
	line-height: 1.3;
	text-align: center;
}
.sign-Up-sec-2 .discount-sec-second-left .offer p span{
    display: block;
}
.sign-Up-sec-2 .discount-sec-second-left .offer-text {
	height: 100%;
	display: flex;
	justify-content: center;
	flex-direction: column;
}
.sign-Up-sec-2 .discount-sec-second-left .offer-text h3 {
	color: #ffffff;
	font-weight: 300;
	font-size: 30px;
	line-height: 1.2;
	width: 80%;
}
.sign-Up-sec-2 .discount-sec-second-left .offer-text p {
	color: #ffffff;
	font-weight: 500;
	font-size: 14px;
	line-height: 1.3;
	padding-top: 10px;
}
.sign-Up-sec-2 .discount-sec-second .btn.discount-sec-second {
	color: #fff;
	background: #d43f33;
	border: 1px solid #d43f33;
	border-radius: 50px;
	padding: 10px 41px;
	margin: 25px 0;
	font-size: 20px;
	font-weight: 300;
}
.sign-Up-sec-2 .discount-sec-second .btn.discount-sec-second:hover {
	background: #a92920;
}
.weekly_act{
    display: flex;
  justify-content: start;
    margin:0 0 114px;
    border: 1px solid #dfdfdf;
    position: relative;
}
.weekly_act::before{
    content: "";
    position: absolute;
    background: url('../assets/images/pricing2/Activities-bg2.png') no-repeat;
    background-position: center;
    padding: 40px 65px;
    background-size: cover;
    height: 100%;
    width: 100%;
}
.weekly-activities #v-pills-tab {
    padding: 30px 0;
}
.weekly-activities #v-pills-tabContent {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 40px 65px;
}
.weekly-activities #v-pills-tab{
position: relative;
}
.weekly-activities #v-pills-tab::before{
    content: '';
    width: 1px;
    height: 100%;
    position: absolute;
    background: #dfdfdf;
    top: 0;
    bottom: 0;
    right: 10%;
}
.weekly-activities .weekly-activities-inner h2{
    position: relative;
}
.quesn .quesn_text{
    text-align: center;
}
.quesn .quesn_text h3{
    font-family: "Inter", sans-serif;
    width: 44%;
    margin: 0 auto;
    margin-bottom: 4.5%;
    font-size: 45px;
    font-weight: lighter;
}
.quesn .quesn_text h3 span{
    font-weight: 700;
}
.quesn .quesn_text2{
    margin-top: 100px;
}
.quesn .quesn_text2 h3{
    font-family: "Inter", sans-serif;
    width: 80%;
    text-align: center;
    margin: 0 auto;
    margin-bottom: 4.5%;
    font-size: 45px;
    font-weight: lighter;
}
.quesn .quesn_text2 h3 span{
    font-weight: 700;
}
.quesn .maintanance .maintan1 h4{
    font-family: "Inter", sans-serif;
    font-size: 21px;
    margin: 0;
    font-weight: 600;
    color: black;
}
.quesn .maintan_btn{
    text-align: center;
    margin-bottom: 100px;
}
.quesn .maintan_btn .m_btn{
    background: #D43F33;
    padding: 20px 44px;
    font-size: 20px;
    color: #fff;
    border-radius: 50px;
    display: inline-block;
    transition: 0.3s ease;
}
.quesn .maintan_btn .m_btn:hover{
    background: #ab332a;
}
.quesn .maintanance .maintan1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
    width: 100%;
}
.quesn .maintanance .maintan1 .main_tan_img{
    cursor: pointer;
}
.plus-icon {
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    margin-left: auto;
    content: "";
    background-image: url('../assets/images/pricing2/plus.png');
    background-repeat: no-repeat;
    background-size: 1.25rem;
    transition: transform .2s ease-in-out;
    background-position: center;
    background-size: cover;
    padding: 13px 0px;
    display: flex;
}

.minus-icon {
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    margin-left: auto;
    content: "";
    background-image: url('../assets/images/pricing2/minus.png');
    background-repeat: no-repeat;
    background-size: 1.25rem;
    transition: transform .2s ease-in-out;
    background-position: center;
    background-size: cover;
    padding: 13px 0px;
    display: flex;
}

/* .accordion-button:not(.collapsed)::after {
    background-image: url('../assets/images/pricing2/minus.png');
} */

.accordion-item {
    border: none;
    border: 1px solid #dfdfdf;
}
.quesn .maintanance .accordion-item{
    margin: 26px 0;
}
.quesn .maintanance .accordion .accordion-item .accordion-button{
    background-color: #fff;
}
/* responsive css */
@media only screen and (max-width: 1400px) {

.banner-content .hero-text h2{
        font-size: 50px;
        line-height: 55px;
}

.banner-content .hero-text p{
    font-size:22px;
    line-height: 30px;
}

.sign-Up-sec-text p{
    font-size:40px;
}

.discount-2 .discount-sec .discount-sec-fast h2{
    font-size: 43px;
}

}

@media only screen and (max-width:1200px) {
    .explore-plans-2.custom-padding {
    padding: 50px 0;
   }
   .banner-content .hero-text h2{
    font-size:40px;
    line-height: 45px;
   }
   .sign-Up-sec-text p {
    font-size: 36px;
  }
  .quesn .quesn_text h3{
    width: 80%;
  }
  .reigning-market-sec .reigning-market-gray:before{
    display: none;
  }
  .reigning-market-sec .reigning-market-black h6{
    font-size:37px;
    line-height:43px;
  }
  .reigning-market-sec .reigning-market-black p{
    font-size:20px;
    line-height:24px;
  }
  .sign-Up-sec-text p{
    text-align: center;
  }
  .sign-Up-sec-btn{
    justify-content: center;
  }
  .weekly-activities #v-pills-tabContent{
    padding:30px;
    width: 100%;
  }
  .weekly-activities #v-pills-tab{
    width:100%;
  }
  .quesn .quesn_text2 h3{
    font-size:35px;
    line-height: 39px;
    width:100%;
  }
  .btn-end{
    justify-content: center;
  }
  .explore-plans-2 .custom-img-before{
    justify-content: center;
  }

  .sign-Up-sec-text p{
    margin-bottom: 20px;
  }
}
@media only screen and(max-width:821px){
    .weekly-activities #v-pills-tab{
        width: 40%;
    }
    .quesn .quesn_text h3 {
    font-family: "Inter", sans-serif;
    width: 91%;
    }
    .quesn .quesn_text2 h3 {
    font-family: "Inter", sans-serif;
    width: 100%;
    text-align: center;
    margin: 0 auto;
    margin-bottom: 4.5%;
    font-size: 37px;
    }
    .quesn .quesn_text2 h3 {
    font-size: 30px;
    }
    .quesn .maintan_btn {
    margin-bottom: 60px;
    }
    .banner-content .hero-text h2{
        margin-top: 45px;
    }
    .reigning-market-sec .reigning-market-gray::before { 
    left: 74%;
    }
    .reigning-market-sec .reigning-market-gray p {
        font-size: 19px;

    }
    .reigning-market-sec .reigning-market-black h6 {
        font-size: 45px;
    }
    .reigning-market-sec .reigning-market-black p {
        font-size: 18px;
    }
    .core-activities.custom-padding {
    padding: 50px 0;
    }
    .core-activities .core-activities-left p{
        margin-bottom: 50px;
    }
    .sign-Up-sec-btn {
    display: flex;
    justify-content: center;
    }
    .explore-plans-2 p {
    padding: 25px 0 50px;
    }
    .explore-plans-2.custom-padding {
        padding: 50px 0;
    }
    .custom-gap {
    --bs-gutter-x: 20px;
    --bs-gutter-y: 20px;
    }
    .discount-2 .discount-sec .discount-sec-fast h2 {
        font-size: 31px;
    }
    .btn-end {
    justify-content: center;
    }
    .maintenance-offers-2.custom-padding {
    padding: 50px 0 50px;
    }
    .weekly_act {
    margin: 0 0 80px;
    }
    .sign-Up-sec-2{
    margin-bottom: 80px;
    }
    .quesn .quesn_text h3{
        margin-bottom: 7.5%;
    }
    .quesn .quesn_text2 {
    margin-top: 80px;
    }
    .quesn .quesn_text2 h3 {
    margin-bottom: 7.5%;
    }
    .weekly-activities .nav-pills .nav-link {
    font-size: 19px;
    }
}
@media only screen and (max-width:767px) {
    .sign-Up-sec-2 .discount-sec-second .btn.discount-sec-second{
        margin-top: 0;
    }
    .sign-Up-sec-2{
    padding: 30px 10px;
}
    .weekly_act{
        flex-direction: column;
    }
    .weekly_act::before{
        padding: 0 0;
    }
    .weekly-activities #v-pills-tab{
        width: 100%;
    }
    .weekly-activities #v-pills-tab{
        border-bottom: 1px solid #dfdfdf;
    }
    .weekly-activities #v-pills-tabContent{
        width: 100%;
    }

    .banner-content .hero-text h2{
    font-size: 30px;
    line-height: 40px;
  }
  .reigning-market-sec .reigning-market-gray{
    width:100%;
    text-align:center;
    padding:20px 0;
  }
  .core-activities .core-activities-left h2{
    font-size:42px;
    
  }
  .core-activities .core-activities-left p{
    width:100%;
  }
  .sign-Up-sec{
    padding:20px;
  }
  .sign-Up-sec-text {
    font-size:25px;
  }
  .explore-plans-2 h2{
    font-size:35px;
  }
  .discount-2 .discount-sec{
    padding:20px;
  }
  .discount-2 .discount-sec .discount-sec-fast h2{
    font-size:25px;
    line-height:30px;
  }
  .maintenance-offers-2 .maintenance-offers-text h2{
    font-size:27px;
    line-height:33px;
  }
  .discount-2 .discount-sec-second-left .offer-text{
    text-align:center;
    padding: 20px 0;
  }
  .discount-2 .discount-sec-second-left .offer-text h3{
    text-align:center;
    width:100%;
    font-size: 24px;
  }
  .discount-2 .discount-sec .discount-sec-second .btn.discount-sec-second{
    margin-top: 0;
  }
  .discount-2 .discount-sec-second-left .offer-text p{
    text-align: center;
    
  }
  .maintenance-offers-2 .maintenance-offers-text p{
    width:100%;
  }
  .weekly-activities #v-pills-tab::before{
   display:none;
  }
  .sign-Up-sec-2 .discount-sec-second-left .offer-text h3{
    
    text-align:center;
  }
  .sign-Up-sec-2 .discount-sec-second .btn.discount-sec-second{
    padding: 10px 23px;
  }
  .quesn .quesn_text h3{
    width:100%;
    font-size:32px;
  }
  .quesn .quesn_text2 h3{
    font-size:30px;
    line-height:35px;
  }
  .quesn .quesn_text2 h3 {
    font-size: 26px;
    line-height: 35px;
  }
  .weekly-activities .weekly-activities-inner h2{
    font-size:27px;
    line-height:33px;
  }
  .sign-Up-sec-2 .discount-sec-second-left .offer{
    padding:26px;
  }
}
/* 01.04.24 */
.banner-content {
    padding: 141px 0;
    min-height: auto;
    height: auto;
}
.custom-img-before::before {
    background-size: contain;
}
@media (max-width:1400px){
    .discount-sec-second-left .offer p {
        font-size: 16px;
    }
    .quesn .quesn_text2 h3,
    .maintenance-offers .maintenance-offers-text h2{
        font-size: 34px;
        padding-bottom: 35px;
    }
    .sign-Up-sec-2 .discount-sec-second-left .offer p{
        font-size: 16px;
    }
}
@media (max-width:1280px) {
    .excellent-company-section {
        margin-bottom: 150px;
    }
    .explore-plans-2 .custom-img-before::before {
        width: 72px;
        height: 98px;
        right: -26px;
    }
    .sign-Up-sec-2:before {
        width: 151px;
        height: 150px;
        background-size: contain;
        bottom: -60px;
        right: -52px;
    }
    .maintenance-offers.custom-padding {
        padding: 150px 0 100px;
    }
    .sign-Up-sec::before {
        width: 75px;
        height: 85px;
        bottom: -54px;
        left: -50px;
    }
    .sign-Up-sec::after {
        width: 151px;
        height: 199px;
        right: -45px;
    }
    .explore-plans-2 .custom-img-before::before {
    width: 72px;
    height: 98px;
    right: -10px;
}
}
@media (max-width:1199px) {
    .sign-Up-sec-2 .discount-sec-second-left .offer p{
        font-size: 13px;
    }
    .explore-plans-2.custom-padding{
        padding: 100px 0;
    }
    .sign-Up-sec-2 .discount-sec-second-left .offer-text h3 {
        font-size: 22px;
    }
    .discount-2 .discount-sec-second-left .offer p {
        font-size: 13px;
    }
    .discount-2 .discount-sec-second-left .offer{
        padding: 28px;
    }
    .discount-2 .discount-sec .discount-sec-fast h2 {
        font-size: 30px;
    }
    .sign-Up-sec::before {
    left: -39px;
}
.sign-Up-sec::after {
    right: -41px;
}
.sign-Up-sec-2::before {
    width: 111px;
    height: 133px;
    right: -37px;
}
.discount-2 .discount-sec::before {
    width: 144px;
    height: 178px;
    left: -38px;
}
}
@media (max-width:991px){
    .banner-content {
    margin-top: 71px;
}
    .explore-plans-2.custom-padding {
    padding: 100px 0 64px;
}
    .custom-gap {
    --bs-gutter-y: 20px;
}
    .banner-content{
    padding: 50px 0 80px;
    }
    .banner-content .hero-text{
        margin-bottom: 0;
    }
    .maintenance-offers .maintenance-offers-text h2{
        font-size: 30px;
    }
    .maintenance-offers.custom-padding {
        padding: 90px 0 70px;
    }
}
@media (max-width:767px){
    .sign-Up-sec-2 .discount-sec-second-left .offer-text{
        padding: 20px 0;
        text-align: center;
    }
    .sign-Up-sec-2 .discount-sec-second-left .offer-text h3{
        width: 100%;
    }
    .reigning-market-black .row{
        --bs-gutter-y:20px;
    }
    .reigning-market-sec{
        padding: 27px 0 27px;
    }
    .reigning-market-sec .reigning-market-black-inner-left{
        border-bottom: 1px dashed #ffffff;
        border-right: unset;
        padding-bottom: 20px;
    }
    .sign-Up-sec::after {
    right: 0;
}
    .sign-Up-sec-text p {
    font-size: 28px;
    margin-bottom: 18px;
}
.sign-Up-sec::before,
    .reigning-market-sec::after{
        content: unset;
    }
    .discount-sec::before {
        right: 0;
    }
    .custom-img-before::before {
        right: 10px;
    }
    .maintenance-offers .maintenance-offers-text h2{
        font-size: 25px;
    }
    .banner-content {
        padding: 50px 0 50px;
    }
    .discount-2 .discount-sec::before {
    left: 0;
}
.sign-Up-sec-2::before {

    right: 0;
}
.explore-plans-2 .custom-img-before::before {
    width: 72px;
    height: 98px;
    right: 37px;
}
.explore-plans-2.custom-padding {
    padding: 78px 15px 64px;
}

.discount-2 .discount-sec .discount-sec-fast h2{
    font-size:18px;
}
.quesn .maintan_btn .m_btn {
    background: #D43F33;
    padding: 20px 20px;
    font-size: 13px;
}
.quesn .quesn_text2 h3{
    font-size:23px;
}
}
@media (max-width:599px){
    .banner-content .hero-text p {
    font-size: 15px;
    line-height: 1.5;
}
    .discount-2 .discount-sec::before {
        left: -8px;
    }
    .maintenance-offers-2.custom-padding{
        position: relative;
    }
}
</style>